import React from 'react';
import * as Styled from './Main.styles';

const Main = ({ children }) => <Styled.Main>{children}</Styled.Main>;

export default Main;
